"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasher = void 0;
const sha256_1 = require("@noble/hashes/sha256");
const util_1 = require("./util");
const digest64 = (a, b) => sha256_1.sha256.create().update(a).update(b).digest();
exports.hasher = {
    digest64,
    digest64HashObjects: (a, b) => util_1.uint8ArrayToHashObject(digest64(util_1.hashObjectToUint8Array(a), util_1.hashObjectToUint8Array(b))),
};
